import React from 'react';
import './SearchHistory.css';

export const SearchHistory = ({ search }) => {
  return (
    <div className="search-history-container">
      <div className="search-history-header">
        <span className="search-history-user">{search.user}</span>
        {search.timestamp && <span className="search-history-date">{search.timestamp}</span>}
      </div>
      <div className="search-history-content">
        <div className="search-item">
          <div className="search-query">
            <span className="search-icon">🔍</span>
            {search.query}
          </div>
        </div>
      </div>
    </div>
  );
}; 